<template>
  <div class="text-xs-center">
   
    
      <v-card
        color="blue-darken"
        dark
      >
        <v-card-text>
          <span class="title">Your fresh keys</span>
          <br/>
          <br/>
          <span>{{keys.stdout}}</span>
          <input type="hidden" id="keys" :value="keys.stdout">
          <br/>
          <br/>
          <v-btn small @click="copyText()">{{copyBtn}}</v-btn>
          <br/>
          <br/>
          <b>** Ensure you save these keys in a safe location, we wont be able to help you recover them.</b>
          <br/>
          <br/>
        </v-card-text>
        
      </v-card>
     
  </div>
</template>

<script>
  import store from "@/store"

  export default {
    data () {
      return {
        copyBtn: 'copy'
      }
    },
    props: {
      keys: String
    },
    methods: {
      copyText () {
          let testToCopy = document.querySelector('#keys')
          testToCopy.setAttribute('type', 'text')    // 不是 hidden 才能複製
          testToCopy.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            this.copyBtn = 'copied to clipboard!'
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          testToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
    },
    destroyed: function () {
      this.$store.commit('eosJsFunc/keyDestroy')
    }
  }
</script>

<style>
  .test {
    color:red;
  }
</style>
